import React from 'react';

import Icon from '@ant-design/icons';
import { useDimensionWorkflow, useTopPanelStore } from '@hooks';
import ViewDetailIcon from '@icons/emp/view_detial.svg';
import { useCustomDimensionPanelStore } from '@src/emp-3.0/components/custom-dimension/custom-dimension-panel/store';
import { ICustomDimensionsItem } from '@src/emp-3.0/types';
import PermissionButton from '@src/emp-3.0/components/PermissionButton';
import { useNavigate } from 'react-router-dom';
interface IEditUserDefinedDimensionMenu {
  customDimension: ICustomDimensionsItem;
}

const EditUserDefinedDimensionMenu: React.FC<IEditUserDefinedDimensionMenu> = ({
  customDimension,
}) => {
  const navigate = useNavigate();
  const { openCustomDimensionPanel } = useTopPanelStore();
  const isNewWorkflow = useDimensionWorkflow();
  const { setCustomDimensionPayload } = useCustomDimensionPanelStore((state) => state);

  const handleEditUserDefinedDimension = () => {
    if (!customDimension) return;
    if (isNewWorkflow) {
      navigate(`/workflow/dimension/${customDimension.id}/eventLooker`);
      return;
    }

    openCustomDimensionPanel();
    setCustomDimensionPayload({ ...customDimension, custom_dimension_id: customDimension.id });
  };

  return (
    <PermissionButton
      onClick={handleEditUserDefinedDimension}
      disabledStyle={{ color: 'rgba(0, 0, 0, 0.65)' }}
      lackPermissionToolTip="Non-Admin Permission, go to management for details"
    >
      <Icon
        style={{
          marginLeft: '4px',
          cursor: 'pointer',
          width: '20px',
        }}
        component={ViewDetailIcon}
      />
    </PermissionButton>
  );
};

export default EditUserDefinedDimensionMenu;
